<template>
    <div>
        <!-- b-model can't be used here (@setLocation update function does not work), so simulate modal background -->
        <div class="panel-backdrop"></div>
        <div class="wfst-panel shadowSmall">
            <div class="panel-header">
                <h3 class="panel-header-title">
                    {{ displayAlias }}
                </h3>
                <!-- Close icon -->
                <icon-close
                    @close="$emit('cancel')"
                    class="d-inline-block float-right"
                />
            </div>
            <div class="panel-content">
                <wfs-t-form
                    :layerThemeObject="layerThemeObject"
                    :layerObject="layerObject"
                    :isEditing="isEditing"
                    @setLocation="$emit('setLocation', $event)"
                    @cancel="$emit('cancel')"
                    @finished="$_updateSelection($event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import {
        SELECTION_TYPES,
        FEEDBACKS_STEPS,
        FEEDBACKS_GEOMETRY_TYPES
    } from '../../../../constants';
    import { getFeatureInfoAtPosition } from '../../../../services/map/feature/selection';
    import IconClose from '../../../IconClose.vue';
    import WfsTForm from './WfsTForm.vue';
    import { createPointArray } from '../../../../services/feedback';
    import { Polygon } from 'ol/geom';
    import { getCenter as OlGetCenter } from 'ol/extent';

    export default {
        name: 'WfsTEdit',
        components: {
            'icon-close': IconClose,
            'wfs-t-form': WfsTForm
        },
        props: {
            layerId: { type: Number, required: true },
            themeLayerId: { type: String, required: true },
            layerObject: { type: Object, required: true },
            isEditing: { type: Boolean, default: false }
        },
        data() {
            return { };
        },

        created() {
            this.mode = FEEDBACKS_STEPS.WFST_EDIT;
        },

        computed: {
            ...mapGetters([
                'isMobile',
                'getSelectionData',
                'getLayerById'
            ]),
            layerThemeObject: function () {
                return this.getLayerById(this.themeLayerId)?.data;
            },
            displayAlias: function () {
                const title = this.layerThemeObject?.title ?? '';
                return (this.isEditing) ? this.$t('changeWfsTAttributes', [title]) : this.$t('addWfsTAttributes', [title]);
            }
        },

        methods: {
            ...mapMutations(['ADD_SELECTION']),
            async $_updateLayer(layerData, layerId) {
                const selectionData = { ...this.getSelectionData };
                const updateLayer = this.getLayerById(layerId);

                const firstcoordinates =
                    layerData.geometryType === FEEDBACKS_GEOMETRY_TYPES.POINT
                        ? layerData.location
                        : layerData.location.split(' ').slice(0, 1)[0];
                let position = firstcoordinates.split(',').map((p) => Number(p));

                if (
                    layerData.geometryType === FEEDBACKS_GEOMETRY_TYPES.POLYGON
                ) {
                    const polygon = new Polygon([
                        createPointArray(layerData.location)
                    ]);
                    position = OlGetCenter(polygon.getExtent());
                }

                const mapObject = this.$store.getters.getMainMap;
                const result = await getFeatureInfoAtPosition(
                    this.$store,
                    mapObject.map,
                    updateLayer,
                    position,
                    mapObject.viewport.resolution
                );
                const updatedFeature = result.find(
                    (updatedFeatureData) =>
                        updatedFeatureData.getId() === layerData.id
                );
                const results = selectionData?.results;

                if (result && results && updatedFeature) {
                    const newSelection = results.map(({ features, layer }) => {
                        if (layer.id === updateLayer.id) {
                            return {
                                layer,
                                features: [
                                    ...features.filter(
                                        (feat) => feat.getId() !== layerData.id
                                    ),
                                    updatedFeature
                                ]
                            };
                        }
                        return { features, layer };
                    });
                    this.ADD_SELECTION({
                        location: null,
                        results: newSelection,
                        type: SELECTION_TYPES.SELECTION
                    });
                }
            },
            async $_updateSelection({ layerData, themeObject }) {
                if (this.mode === FEEDBACKS_STEPS.WFST_EDIT) {
                    layerData.forEach(async (layer) => {
                        await this.$_updateLayer(layer, themeObject.customId);
                    });
                }
                // Load wfst-layer if needed
                let ids = themeObject.customId.split('-');
                if (ids.length > 0) {
                    let themeId = +ids[0];
                    await this.$store.dispatch('loadTheme', {
                        themeId, layerId: themeObject.id, toggledTheme: false
                    });
                }
                this.$emit('finished');
            }
        },

        watch: {}
    };
</script>

<style lang="scss">
    .wfst-panel {
        @include margin-top-navbar;
        position: fixed;
        right: 0;
        left: auto;
        width: 550px;
        margin: 0px;
        bottom: 0;
        background: white;
        z-index: 1000;
        display: flex;
        flex-direction: column;
    }

.panel-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    opacity: 0.5;
    background-color: #000;
}

@media (max-width: $tablet-width) {
    .wfst-panel {
        left: 0% !important;
        width: auto !important;
    }
}
</style>
